module.exports = __webpack_public_path__ + "nav-arrow.svg?4d6f3f579552690f045c22498fdcba8b";